/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_DescriptionInputs */

const et_plan_website_description = /** @type {(inputs: Plan_Website_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kui sul ei ole veel korralikku veebilehte või vajad uut lehte, mis jätab hea esmamulje ja aitab kliendil ühendust võtta.`)
};

const en_plan_website_description = /** @type {(inputs: Plan_Website_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you don't yet have a proper website or need a new one that makes a strong first impression and helps customers contact you.`)
};

/**
* | output |
* | --- |
* | "If you don't yet have a proper website or need a new one that makes a strong first impression and helps customers contact you." |
*
* @param {Plan_Website_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_description = /** @type {((inputs?: Plan_Website_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_description(inputs)
	return en_plan_website_description(inputs)
});